import { suggestionList } from './suggestions';

export interface CompanyResult {
  companyName: string;
  companyNumber: string;
  status?: string;
  address?: string;
  sicCodes?: string[];
}

/** Companies House name lookup (our own /api/companies/search), from 2 characters, debounced. */
export function attachCompanyAutocomplete(input: HTMLInputElement, onSelect: (r: CompanyResult) => void): void {
  const list = suggestionList(input);
  let timer: ReturnType<typeof setTimeout> | null = null;
  input.addEventListener('input', () => {
    const term = input.value.trim();
    if (timer) clearTimeout(timer);
    if (term.length < 2) { list.close(); return; }
    timer = setTimeout(async () => {
      try {
        const res = await fetch(`/api/companies/search?q=${encodeURIComponent(term)}`);
        if (!res.ok) { list.close(); return; }
        const data = await res.json() as { results?: CompanyResult[] };
        list.show(data.results || [], (r) => r.companyName, (r) => r.companyNumber + (r.status ? ' · ' + r.status : ''), (r) => {
          input.value = r.companyName;
          onSelect(r);
        });
      } catch {
        list.close();
      }
    }, 250);
  });
  input.addEventListener('blur', () => setTimeout(list.close, 150));
}
